import EditMetricModal from './EditMetricModal';

export default EditMetricModal;
